import axios from 'axios';
import { useMutation } from '@tanstack/react-query';
import { useCurrentUserDetails } from 'entities/user/model';
import { useAuth0 } from '@auth0/auth0-react';

export const useCompleteCrossChainTransfer = () => {
  const { getAccessTokenSilently } = useAuth0();
  const { getCurrentOrganizationId } = useCurrentUserDetails();
  return useMutation({
    mutationKey: ['complete-cross-chain-transfer'],
    mutationFn: async ({
      transferIds,
      transactionHash,
    }: {
      transactionHash: string;
      transferIds: string[];
    }) => {
      const token = await getAccessTokenSilently();
      const res = await axios.post<{
        result: {};
      }>(
        `${process.env.REACT_APP_SERVER_URL}/api/public/cross-chain-transfer/asset-transfer/complete`,
        {
          transferIds,
          organizationId: getCurrentOrganizationId(),
          transactionHash,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return res.data?.result;
    },
  });
};

export const useCompleteCrossChainTransferByInvoice = () => {
  const { getAccessTokenSilently } = useAuth0();
  const { getCurrentOrganizationId } = useCurrentUserDetails();
  return useMutation({
    mutationKey: ['complete-cross-chain-transfer-by-invoice'],
    mutationFn: async ({
      invoiceIds,
      transactionHash,
    }: {
      transactionHash: string;
      invoiceIds: string[];
    }) => {
      const token = await getAccessTokenSilently();
      const res = await axios.post<{
        result: {};
      }>(
        `${process.env.REACT_APP_SERVER_URL}/api/public/cross-chain-transfer/invoice/complete`,
        {
          invoiceIds,
          organizationId: getCurrentOrganizationId(),
          transactionHash,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return res.data?.result;
    },
  });
};
